import React from "react";
import Header from "../components/Layouts/AppHeader/AppHeader";
import SignIn from "../components/Layouts/SignIn";
import ForgotPassword from "../components/Layouts/ForgotPassword";
import { Routes } from "../states/States";
import Homepage from "../views/home";
import DataTable from "../components/Layouts/RiderDetailsTracking/RiderDetailsTracking";
import CreateStore from "../components/Layouts/CreateStore/CreateStore";
import TeamAndSpocs from "../components/Layouts/TeamAndSpocs/TeamAndSpocs";
import RiderKyc from "../components/Layouts/RiderKyc/RiderKyc";
import AlluserReport from "../components/Layouts/TlCmTable/TlCmTable";
import AllotedUserReport from "../components/Layouts/AllotedUserReport";
import PunchInTable from "../components/Layouts/PunchInTable";
import NewRiderDemand from "../components/Layouts/NewRiderDemand";
import FieldVisitReport from "../components/Layouts/FieldVisitReport";
import CreateUser from "../components/Layouts/CreateUser";
import ChangeTl from "../components/Layouts/ChangeTl";
import ManageStore from "../components/Layouts/ManageStore";
import RiderDeatilKyc from "../components/Layouts/RiderDetailsKyc/RiderDetailsKyc";
import NewFleetDemand from "../components/Layouts/NewFleetDemand/NewFleetDemand";
import NewFleetDemandForm from "../components/Layouts/NewFleetDemand/NewFleetDemandForm";
import TicketAndGrievances from "../components/Layouts/TicketsAndGrievances/TicketsAndGrievances";
import Profile from "../components/Layouts/Profile/Profile";
import LiveTracking from "../components/Layouts/liveTrackingRider/liveTrackingRider";
import HyperTrackHomepage from "../components/Layouts/HyperTrack/HomePage";
import ThreewheelerTracker from "../components/Layouts/HyperTrack/3wTracker";
import DistanceReportList from "../components/Layouts/HyperTrack/DistanceReport";
import DistanceReportYearWiseList from "../components/Layouts/HyperTrack/DistanceReportYearWise";
import AdminSignIn from "../components/Layouts/AdminSignIn";
import RiderTrack from "../components/Layouts/HyperTrack/ridertracknew/Ridertrack";
import RiderTrackThreeWheeler from "../components/Layouts/HyperTrack/ridertrackthreewheeler/Ridertrack";
import RiderWholeJourney from "../components/Layouts/HyperTrack/riderwholejurney/googleMapLive";
import Threewheeler from "../components/Layouts/HyperTrack/3wheeler";
import AllThreewheeler from "../components/Layouts/HyperTrack/all3wheeler";
import ManageB2CClients from "../pages/ManageB2CClients/ManageB2CClients";
import { normalizeRole } from "../utils/normalizeRole";

import IotTracker from "../components/Layouts/IotTracker";
import MobileDataTracker from "../components/Layouts/HyperTrack/mobiledatatracker/googleMapLive";
import MobileTracker from "../components/Layouts/MobileTracker";
import MobileTrackerMap from "../components/Layouts/HyperTrack/mobiletrackermap/googleMapLive";
import { Navigate } from "react-router";
import ScooterOwner from "../pages/ScooterOwner/ScooterOwner";

const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const isAuthenticated = localStorage.getItem("access_token");
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return children;
};
const RequireAuthAdmin = ({ children }: { children: JSX.Element }) => {
  const isAuthenticated = localStorage.getItem("access_token");
  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }
  return children;
};

const RequireRole = ({ children, role }: { children: JSX.Element; role: string }) => {
  if (!localStorage.getItem("access_token")) return <Navigate to="/" replace />;
  if (normalizeRole(localStorage.getItem("userRole")) !== role) return <Navigate to="/Dashboard" replace />;
  return children;
};


const CommonRoutes: Array<Routes> = [
  {
    path: "/header",
    element: (<RequireAuth><Header /></RequireAuth>),
  },
  {
    path: "/Dashboard",
    element: (<RequireAuth><Homepage /></RequireAuth>),
  },

  // {
  //   path: "/create-hub",
  //   element: <CreateNewHub />,
  // },

  {
    path: "/",
    element: <SignIn />,
  },
  {
    path: "/forgotpassword",
    element: <ForgotPassword />,
  },
  {
    path: "/teamAndSpocs",
    element: <RequireAuth><TeamAndSpocs /></RequireAuth>,
  },
  {
    path: "/riderKyc",
    element: (<RequireAuth><RiderKyc /></RequireAuth>),
  },
  {
    path: "/alluserReport",
    element: (<RequireAuth><AlluserReport /></RequireAuth>),
  },
  {
    path: "/punchInTable",
    element: (<RequireAuth><PunchInTable /></RequireAuth>),
  },
  {
    path: "/newRiderDemand",
    element: (<RequireAuth><NewRiderDemand /></RequireAuth>),
  },
  {
    path: "/fieldVisitReport",
    element: (<RequireAuth><FieldVisitReport /></RequireAuth>),
  },
  {
    path: "/allottedUserReport",
    element: (<RequireAuth><AllotedUserReport /></RequireAuth>),
  },
  {
    path: "/riderdeatilkyc",
    element: (<RequireAuth><RiderDeatilKyc /></RequireAuth>),
  },
  {
    path: "/changetl",
    element: (<RequireAuth><ChangeTl /></RequireAuth>),
  },
  {
    path: "/managestore",
    element: (<RequireAuth><ManageStore /></RequireAuth>),
  },
  {
    path: "/manageB2CClients",
    element: (<RequireAuth><ManageB2CClients /></RequireAuth>),
  },
  {
    path: "/scooter-owner",
    element: <RequireRole role="ROLE_FLEET_SUPER_ADMIN"><ScooterOwner /></RequireRole>,
  },
  {
    path: "/createuser",
    element: (<RequireAuth><CreateUser /></RequireAuth>),
  },
  {
    path: "/riderDetailsTracking",
    element: <RequireAuth><DataTable /></RequireAuth>,
  },
  {
    path: "/newFleetDemand",
    element: <RequireAuth><NewFleetDemand /></RequireAuth>,
  },
  {
    path: "/createStore",
    element: <RequireAuth><CreateStore /></RequireAuth>,
  },
  {
    path: "/newFleetDemandForm",
    element: <RequireAuth><NewFleetDemandForm /></RequireAuth>,
  },
  {
    path: "/ticketAndGrievances",
    element: <RequireAuth><TicketAndGrievances /></RequireAuth>,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/liveTrackingRider",
    element: <LiveTracking />,
  },
  {
    path: "/zypptracker",
    element: <RequireAuthAdmin><HyperTrackHomepage /></RequireAuthAdmin>,
  },
  {
    path: "/zypptracker/distanceReport",
    element: <RequireAuthAdmin><DistanceReportList /></RequireAuthAdmin>,
  },
  {
    path: "/zypptracker/distanceReportYearWise",
    element: <RequireAuthAdmin><DistanceReportYearWiseList /></RequireAuthAdmin>,
  },
  {
    path: "/zypptracker/threewheelertracker",
    element: <RequireAuthAdmin><ThreewheelerTracker /></RequireAuthAdmin>,
  },
  {
    path: "/zypptracker/threewheelerlist",
    element: <RequireAuthAdmin><AllThreewheeler /></RequireAuthAdmin>,
  },
  {
    path: "/admin",
    element: <AdminSignIn />,
  },
  {
    path: "/zypptracker/ridertrack",
    element: <RequireAuthAdmin><RiderTrack /></RequireAuthAdmin>,
  },
  {
    path: "/zypptracker/riderwholejourney",
    element: <RequireAuthAdmin><RiderWholeJourney /></RequireAuthAdmin>,
  },
  {
    path: "/zypptracker/threewheeler",
    element: <RequireAuthAdmin><Threewheeler /></RequireAuthAdmin>,
  },
  {
    path: "/zypptracker/ridertrackthreewheeler",
    element: <RequireAuthAdmin><RiderTrackThreeWheeler /></RequireAuthAdmin>,
  },
  {
    path: "/zypptracker/iottracker",
    element: <RequireAuthAdmin><IotTracker /></RequireAuthAdmin>,
  },
  {
    path: "/zypptracker/mobiledatatracker",
    element: <RequireAuthAdmin><MobileDataTracker /></RequireAuthAdmin>,
  },
  {
    path: "/zypptracker/mobiletracker",
    element: <RequireAuthAdmin><MobileTracker /></RequireAuthAdmin>,
  },
  {
    path: "/zypptracker/mobiletrackermap",
    element: <RequireAuthAdmin><MobileTrackerMap /></RequireAuthAdmin>,
  },
];
export const Router: Array<Routes> = [
  ...CommonRoutes,
  /**
   *@description
   * Url to Embeded in Iframe
   *
   */
  // {
  //   path: "", // test route
  //   element: <Header />,
  //   children: [
  //     ...CommonRoutes,
  //     {
  //       path: "*", // test route
  //       element: <div>NOT FOUND</div>,
  //     },
  //   ],
  // },
];
